"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Printer = function Printer(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement(
      "g",
      { fill: "#000", fillRule: "evenodd" },
      _react2.default.createElement("path", { d: "M14 12v4H4v-4H1V5h16v7h-3zM6 9v5h6V9H6z" }),
      _react2.default.createElement("path", { fillRule: "nonzero", d: "M4 2h10v2H4z" })
    )
  );
};

exports.default = Printer;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Printer.js
// module id = 697
// module chunks = 0